import { useMutation } from '@tanstack/react-query';
import { axios } from '@/lib/axios/axios';
import { MESSAGING_API_BASE } from '../config';
import { AddMembersBody } from '../types/backend';

export type AddMembersDTO = {
  channelId: number;
  userIds: number[];
};

const addMembers = async (
  data: AddMembersDTO
): Promise<{ success: boolean }> => {
  const { channelId, userIds } = data;

  const body: AddMembersBody = {
    'user-ids': userIds,
  };

  return axios.post(
    `${MESSAGING_API_BASE}/channels/${channelId}/members`,
    body
  );
};

export const useAddMembers = () => {
  return useMutation({
    mutationFn: (data: AddMembersDTO) => addMembers(data),
  });
};
